import React, { useState } from 'react';
import { Box, ImageList, ImageListItem, ImageListItemBar, IconButton } from '@mui/material';
import { ZoomIn } from '@mui/icons-material';
import PhotoLightbox from './PhotoLightbox';

const PhotoGallery = ({ photos, cols = 4 }) => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const handlePhotoClick = (index) => {
    setSelectedIndex(index);
    setLightboxOpen(true);
  };

  return (
    <Box>
      <ImageList cols={cols} gap={8}>
        {photos.map((photo, index) => (
          <ImageListItem key={photo.id}>
            <img src={photo.medium_url || photo.thumbnail_url || photo.url} alt={photo.caption || photo.original_name} loading="lazy" style={{ height: 200, objectFit: 'cover', cursor: 'pointer' }} onClick={() => handlePhotoClick(index)} />
            <ImageListItemBar title={photo.caption} actionIcon={<IconButton sx={{ color: 'rgba(255, 255, 255, 0.9)' }} onClick={() => handlePhotoClick(index)}><ZoomIn /></IconButton>} />
          </ImageListItem>
        ))}
      </ImageList>
      <PhotoLightbox photos={photos} initialIndex={selectedIndex} open={lightboxOpen} onClose={() => setLightboxOpen(false)} />
    </Box>
  );
};

export default PhotoGallery;
